import { atom } from 'recoil';

import { Message } from '@app/types/message';

export const notificationState = atom<Message | undefined>({
  default: undefined,
  key: 'notificationState',
});
